import React from 'react';
import TopBar from '../../../../generic/Utils/TopBar';
import ChrTab from '../../../../generic/Utils/ChrTab';
import TabContents from './TabContents';
import { useDispatch } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';

const App = props => {
  const tabKeyLabelMap = props.data.tabKeyLabelMap;
  const tabKeys = Object.keys(tabKeyLabelMap);
  const tabNames = tabKeys.map(tabKey => tabKeyLabelMap[tabKey]);
  const dispatch = useDispatch();

  const onTabSelect = tabName => {
    dispatch(eventsListingActions.updateCurrentTab(getTabKeyFromText(tabName)));
    dispatch(eventsListingActions.setPage(0));
  };

  const getTabKeyFromText = tabName => {
    return tabKeys.find(tabKey => tabKeyLabelMap[tabKey] === tabName);
  };

  return (
    <div className='cui-events-listing'>
      {
        props.data.topBarTitle && <TopBar
          title={ props.data.topBarTitle }
          titleClass='header-font-md'
          containerClass={ `p-sm p-t-md ${ tabNames.length <= 1 ? 'boxshadow-bottom' : '' }` }
        />
      }
      <div className="cui-layout-rounded-iboxes">
        <ChrTab
          defaultActiveKey={ tabKeyLabelMap[props.data.initialState.currentTab] }
          tabNames={ tabNames }
          onTabSelect={ onTabSelect }
          newUx={ false }
        >
          {
            tabName => <div className={ props.data.topBarTitle ? 'p-4 cui-react-wrapper-content' : '' }>
              <TabContents
                tabKey={ getTabKeyFromText(tabName) }
                { ...props.data }
              />
            </div>
          }
        </ChrTab>
      </div>
    </div>
  )
};

export default App;